import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/context/I18nContext";
import { ug } from "@/i18n/usage_i18n";
import { AlertTriangle } from "lucide-react";

export default function QuotaAlertPill() {
  const { farm } = useAuth();
  const { lang } = useI18n();
  const navigate = useNavigate();
  const [usage, setUsage] = useState(null);

  useEffect(() => {
    if (!farm) return;
    let alive = true;
    const load = () => api.get("/usage").then(({ data }) => { if (alive) setUsage(data); }).catch(() => {});
    load();
    const onFocus = () => load();
    window.addEventListener("focus", onFocus);
    window.addEventListener("mpf:usage-changed", load);
    const iv = setInterval(load, 60000);
    return () => { alive = false; window.removeEventListener("focus", onFocus); window.removeEventListener("mpf:usage-changed", load); clearInterval(iv); };
  }, [farm]);

  if (!usage) return null;
  const m = usage.metrics || {};
  const overCount = Object.values(m).filter((v) => v.limit >= 0 && v.used >= v.limit).length;
  if (!overCount) return null;

  return (
    <button
      onClick={() => navigate("/app/abonnement")}
      data-testid="quota-alert-pill"
      title={ug(lang, "alert")}
      className="inline-flex items-center gap-1.5 rounded-full bg-red-100 text-red-700 text-xs font-semibold px-2.5 h-8 hover:bg-red-200 transition-colors"
    >
      <AlertTriangle className="h-3.5 w-3.5" />
      <span className="hidden sm:inline">{ug(lang, "alert")}</span>
      {overCount > 1 ? <span>({overCount})</span> : null}
    </button>
  );
}
